module.exports = __webpack_public_path__ + "img/waff.336e03c5.png";